import React, {PureComponent} from 'react';
import {
  isAuthorizedAction,
  isDashboardCreatedInCurrentOrganization,
} from '../../../helpers/dashboard-helpers';

import {isCurrentUser} from '../../../helpers/user-helpers';
import PropTypes from 'prop-types';
import Menu, {MenuItem} from '../../common/menu/menu';
import {connect} from 'react-redux';

class DashboardOptions extends PureComponent {
  render() {
    return (
      <Menu selectedOrganization={this.props.selectedOrganization}>
        <MenuItem icon="info" onClick={this.props.handleDashboardInfoClick(this.props.dashboard)}>
          View info
        </MenuItem>
        {isAuthorizedAction('privateDashboardWrite') &&
          isCurrentUser(this.props.dashboard.ownerId) &&
          isDashboardCreatedInCurrentOrganization(this.props.dashboard.tenantId) && (
            <MenuItem icon="config" onClick={this.props.openEditPage}>
              Configure
            </MenuItem>
          )}
        {isAuthorizedAction('privateDashboardWrite') && (
          <MenuItem icon="clone" onClick={this.props.onClone}>
            Clone
          </MenuItem>
        )}
        <MenuItem icon="export" onClick={this.props.onExportDashboard}>
          Export dashboard
        </MenuItem>
        {this.props.dashboard.modalFormData.isFavorite ? (
          <MenuItem
            icon="favorite_unchecked"
            onClick={this.props.removeDashboardFromFavorites(
              this.props.dashboard,
              this.props.queryParams
            )}
          >
            Remove from favorites
          </MenuItem>
        ) : (
          <MenuItem
            icon="favorite_checked"
            onClick={this.props.addDashboardToFavorite(
              this.props.dashboard,
              this.props.queryParams
            )}
          >
            Add to favorites
          </MenuItem>
        )}
        {((isAuthorizedAction('privateDashboardWrite') &&
          isCurrentUser(this.props.dashboard.ownerId)) ||
          isAuthorizedAction('dashboardModerate')) && (
          <MenuItem icon="delete" onClick={this.props.toggleDashboardModal(this.props.dashboard)}>
            Delete
          </MenuItem>
        )}
      </Menu>
    );
  }
}

DashboardOptions.propTypes = {
  dashboard: PropTypes.objectOf(PropTypes.any).isRequired,
  toggleDashboardModal: PropTypes.func.isRequired,
  addDashboardToFavorite: PropTypes.func.isRequired,
  removeDashboardFromFavorites: PropTypes.func.isRequired,
  onClone: PropTypes.func.isRequired,
  openEditPage: PropTypes.func.isRequired,
  handleDashboardInfoClick: PropTypes.func.isRequired,
  queryParams: PropTypes.objectOf(PropTypes.any).isRequired,
  selectedOrganization: PropTypes.objectOf(PropTypes.any),
  onExportDashboard: PropTypes.func.isRequired,
};

DashboardOptions.defaultProps = {
  selectedOrganization: null,
};

const mapStateToProps = ({userReducer}) => {
  return {
    queryParams: userReducer.queryParams,
    selectedOrganization: userReducer.selectedOrganization,
  };
};

export default connect(mapStateToProps, null)(DashboardOptions);
